import React, { useState, useEffect } from 'react';
import { Modal, Input, Button, Spin, Select, Alert, Form } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { api } from '../../../../services/api';
import PropTypes from 'prop-types';

const options = [
  { value: '1', label: <FormattedMessage id="virtual_number_option_1" /> },
  { value: '2', label: <FormattedMessage id="virtual_number_option_2" /> },
  { value: '3', label: <FormattedMessage id="virtual_number_option_3" /> },
  { value: '4', label: <FormattedMessage id="virtual_number_option_4" /> },
];

const VirtualNumberView = (props) => {
  const { getFieldDecorator, validateFields } = props.form;
  const intl = useIntl();
  const [quantity, setQuantity] = useState('');
  const [isSubmiting, setIsSubmitting] = useState(false);
  const [virtualNumbers, setVirtualNumbers] = useState([]);
  const [domain, setDomain] = useState('');
  const [errorSubmitting, setErrorSubmitting] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    const domain = window.BX24.getDomain();
    setDomain(domain);

    return () => {
      if (isSubmiting) {
        setIsSubmitting(false);
      }
    };
  }, [isSubmiting]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    validateFields(async (err, _values) => {
      if (!err) {
        try {
          setIsSubmitting(true);

          const formData = new FormData(event.currentTarget);
          formData.append('domain', domain);
          formData.append('quantity', quantity);
          formData.append('virtualNumbers', JSON.stringify(virtualNumbers));

          const { data } = await api.post('addVirtualNumberRequest', formData);

          if (data.success === false) {
            setErrorSubmitting(true);
            setIsSubmitting(false);
            return;
          }

          setFormSubmitted(true);
          setIsSubmitting(false);
        } catch (error) {
          setIsSubmitting(false);
          setErrorSubmitting(true);
        }
      } else {
        return;
      }
    });
  };

  const onCancel = () => {
    props.cancelAction();
  };

  const handleQuantityChange = (value) => {
    setQuantity(value);

    const numFields = parseInt(value, 10);
    setVirtualNumbers(Array(numFields).fill(''));
  };

  const handleVirtualNumberChange = (index, event) => {
    const newVirtualNumbers = [...virtualNumbers];
    newVirtualNumbers[index] = event.target.value;
    setVirtualNumbers(newVirtualNumbers);
  };

  if (errorSubmitting) {
    return (
      <Alert
        message={<FormattedMessage id="virtual_number_error_1" />}
        description={<FormattedMessage id="virtual_number_error_2" />}
        type="error"
        showIcon
        closable
        onClose={() => props.cancelAction()}
        style={{
          position: 'fixed',
          top: '10%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
        }}
      />
    );
  }

  if (formSubmitted) {
    return (
      <Alert
        message={<FormattedMessage id="virtual_number_success_1" />}
        description={<FormattedMessage id="virtual_number_success_2" />}
        type="success"
        showIcon
        closable
        onClose={() => props.cancelAction()}
        style={{
          position: 'fixed',
          top: '10%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
        }}
      />
    );
  }

  return (
    <Modal
      title={<FormattedMessage id="virtual_number_form" />}
      visible={props.visible}
      onCancel={onCancel}
      footer={null}
      width={530}
      style={{ top: 20 }}
    >
      <p style={{ marginBottom: 30, marginTop: 10 }}>
        <FormattedMessage id="virtual_number_form_subtitle" />
      </p>
      <Form onSubmit={handleSubmit}>
        <label htmlFor="name">
          <span style={{ color: 'red' }}>* </span>
          <FormattedMessage id="virtual_number_input_1" />
        </label>
        <Form.Item>
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: <FormattedMessage id="virtual_number_name_error_1" />,
              },
              {
                pattern: /^[a-zA-Z\s]+$/,
                message: <FormattedMessage id="virtual_number_name_error_2" />,
              },
            ],
          })(
            <Input
              id="name"
              name="name"
              placeholder={intl.formatMessage({ id: 'virtual_number_input_1_placeholder' })}
              style={{ marginBottom: 5, marginTop: 5 }}
            />,
          )}
        </Form.Item>
        <label htmlFor="email">
          <span style={{ color: 'red' }}>* </span>
          <FormattedMessage id="virtual_number_input_2" />
        </label>
        <Form.Item>
          {getFieldDecorator('email', {
            rules: [
              {
                required: true,
                message: <FormattedMessage id="virtual_number_email_error_1" />,
              },
              {
                type: 'email',
                message: <FormattedMessage id="virtual_number_email_error_2" />,
              },
            ],
          })(
            <Input
              id="email"
              name="email"
              placeholder={intl.formatMessage({ id: 'virtual_number_input_2_placeholder' })}
              type="email"
              style={{ marginBottom: 5, marginTop: 5 }}
            />,
          )}
        </Form.Item>
        <label htmlFor="whatsapp">
          <span style={{ color: 'red' }}>* </span>
          <FormattedMessage id="virtual_number_input_3" />
        </label>
        <Form.Item>
          {getFieldDecorator('whatsapp', {
            rules: [
              {
                required: true,
                message: <FormattedMessage id="virtual_number_whats_error_1" />,
              },
              {
                pattern: /^[0-9]+$/,
                message: <FormattedMessage id="virtual_number_whats_error_2" />,
              },
            ],
          })(
            <Input
              id="whatsapp"
              name="whatsapp"
              placeholder={intl.formatMessage({ id: 'virtual_number_input_3_placeholder' })}
              style={{ marginBottom: 5, marginTop: 5 }}
            />,
          )}
        </Form.Item>
        <label htmlFor="quantity">
          <span style={{ color: 'red' }}>* </span>
          <FormattedMessage id="virtual_number_input_4" />
        </label>
        <Form.Item>
          {getFieldDecorator('quantity', {
            rules: [
              {
                required: true,
                message: <FormattedMessage id="virtual_number_quantity_error" />,
              },
            ],
          })(
            <Select
              id="quantity"
              placeholder={intl.formatMessage({ id: 'virtual_number_input_4_placeholder' })}
              onChange={(value) => {
                handleQuantityChange(value);
              }}
              style={{ marginBottom: 5, marginTop: 5 }}
            >
              {options.map((option, index) => (
                <Select.Option key={index} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        {virtualNumbers.map((number, index) => (
          <Form.Item>
            {getFieldDecorator(`virtualNumber${index}`, {
              rules: [
                {
                  required: true,
                  message: <FormattedMessage id="virtual_number_virtualized_error" />,
                },
                {
                  pattern: /^[0-9]+$/,
                  message: <FormattedMessage id="virtual_number_whats_error_2" />,
                },
              ],
            })(
              <Input
                id="virtualNumber"
                placeholder={intl.formatMessage({ id: 'virtual_number_request' }) + `${index + 1}`}
                value={number}
                key={index}
                onChange={(e) => handleVirtualNumberChange(index, e)}
              />,
            )}
          </Form.Item>
        ))}
        <div style={{ textAlign: 'center', marginBottom: 10, marginTop: 20 }}>
          <Button type="primary" htmlType="submit">
            {isSubmiting ? (
              <Spin style={{ color: 'white' }} size="small" />
            ) : (
              <FormattedMessage id="virtual_number_send" />
            )}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

VirtualNumberView.propTypes = {
  visible: PropTypes.bool.isRequired,
  cancelAction: PropTypes.func.isRequired,
};

export default Form.create()(VirtualNumberView);
